import { render, staticRenderFns } from "./payroll_header_tab.vue?vue&type=template&id=33acd714&scoped=true"
import script from "./payroll_header_tab.vue?vue&type=script&lang=js"
export * from "./payroll_header_tab.vue?vue&type=script&lang=js"
import style0 from "./payroll_header_tab.vue?vue&type=style&index=0&id=33acd714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33acd714",
  null
  
)

export default component.exports